import PageLayout from "../../components/PageLayout";
import { Box, Grid, Stack, Typography, Button, Dialog, DialogTitle, DialogContent, DialogActions, Slide, IconButton, ListItem, List, FormControlLabel, Checkbox } from '@mui/material';
import explorebg from '../../assets/images/explorebg.svg';
import logo from "../../assets/images/defaults/logo-light.png"
import { ChevronRight, Circle, Close } from '@mui/icons-material';
import { useNavigate } from "react-router-dom";
import { appConfigs, appRoutes, oktaConfigs } from "../../constants/ApplicationConstants";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useOktaAuth } from "@okta/okta-react";
import { setProcessing } from "../../store/ApplicationStore";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function ExploreScreen(){
    const [showDisclaimer, setShowDisclaimer]= useState(false);
    const [agree, setAgree]= useState(false);


    const navigate= useNavigate();
    const dispatch = useDispatch();
    const {oktaAuth}= useOktaAuth();

    function navigateToMenu(){
        dispatch(setProcessing(true));
        navigate(appRoutes.menu);
    }
    async function handleLogout(){
        setShowDisclaimer(false);
        dispatch({type: 'LOGOUT'});
        await oktaAuth.signOut({ postLogoutRedirectUri: window.location.origin + oktaConfigs.oktaLogoutURL });
    };

    return(
        <PageLayout header={false} footer={false} backgroundImage={explorebg}>
            <Box>
                <Grid container spacing={2}  sx={{ flexGrow: 1 }}>
                    <Grid item xs={12} sm={12} md={12} lg={4}>
                        <Box marginLeft={7}>
                            <Stack direction="column" justifyContent="space-between" alignItems="flex-start" spacing={45}>
                                <Box display='flex' flexDirection='column'>
                                    <img alt="explore" src={logo} style={{ width: '100%', height: '100%', marginTop: '2rem' }} />
                                    <Typography sx={{marginTop: '2rem'}} color="lightgray" variant="body1">Turning digital disarray into a treasure trove of organised wisdom gold. Think of us as your trusty needle-finding experts in the vast haystack of information!</Typography>
                                    <Button sx={{ textTransform: 'capitalize', marginTop: '2rem' }} onClick={()=>setShowDisclaimer(true)}  variant="contained" color="white">Explore <ChevronRight style={{marginLeft: '1rem'}} /></Button>
                                    {/* <Box>
                                        <Typography color="gray" fontSize={'0.5rem'}>Disclaimer:</Typography>
                                        <Typography color="gray" fontSize={'0.5rem'}>FOR DEMONSTRATION PURPOSES ONLY</Typography>
                                        <Typography color="gray" fontSize={'0.5rem'}>This information contained in this document should not be construed as a guarantee of any service or product. No financial, investment, or professional advice is being provided and nothing contained herein shall be deemed to constitute any financial, investment, legal, tax or other professional advice in any way. The information contained herein should not be relied on without independent verification or used as a substitute for consultation with professional accounting, tax, legal or other competent advisers.</Typography>
                                    </Box> */}
                                </Box>
                                <Typography position='relative' bottom='10px' color="gray" fontSize={'10px'}>{appConfigs.footerText}</Typography>
                            </Stack>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
            <Dialog fullWidth open={showDisclaimer} TransitionComponent={Transition} keepMounted onClose={()=>{setShowDisclaimer(false);}}>
                <DialogTitle>
                    <IconButton aria-label="close" onClick={()=>{setShowDisclaimer(false);}} sx={{ position: 'absolute', right: 8, top: 8 }}>
                        <Close />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Box>
                        <Typography color="gray" variant='h5'>Disclaimer:</Typography>
                        <List>
                            <ListItem>
                                <Box display='flex'>
                                    <Circle sx={{fontSize: '0.5rem', marginTop: '0.5rem', marginRight: '0.5rem'}} />
                                    <Typography variant='subtitle2'> Please be aware that the outputs have been generated by an Artificial Intelligence model. While efforts have been made to provide accurate and relevant information, there is a possibility of errors or inaccuracies. The response you receive should not be considered as professional or expert advice. We strongly recommend cross-checking the information with reliable sources or consulting a human expert when necessary. The purpose of this product is to assist and provide general information, but it may not always be perfect. Use the information at your own discretion.</Typography>
                                </Box>
                            </ListItem>
                            <ListItem>
                                <Box display='flex'>
                                    <Circle sx={{fontSize: '0.5rem', marginTop: '0.5rem', marginRight: '0.5rem'}} />
                                    <Typography variant='subtitle2'>In order to adhere to legal and security policies, we kindly request that you refrain from entering any confidential and/or personal information into the Generative AI platform.</Typography>
                                </Box>
                            </ListItem>
                            <ListItem>
                                <Box display='flex'>
                                    <Circle sx={{fontSize: '0.5rem', marginTop: '0.5rem', marginRight: '0.5rem'}} />
                                    <Typography variant='subtitle2'>Kindly note that your inputs maybe subject to audit, and may be used for refining the accuracy of responses provided by the product.</Typography>
                                </Box>
                            </ListItem>
                        </List>
                        <FormControlLabel sx={{marginLeft: '0.5rem'}} value={agree} control={<Checkbox checked={agree} onChange={() => setAgree(!agree)} />}  label={<Typography variant="subtitle2" fontWeight='bold'>I acknowledge that I have read, understand and agree to above instructions.</Typography>} />
                    </Box>
                </DialogContent>
                <DialogActions sx={{marginBottom: '1rem', marginRight: '1rem'}}>
                    <Button sx={{ textTransform: 'capitalize' }} variant='outlined' color='primary' onClick={()=>{handleLogout()}}>Disagree</Button>
                    <Button sx={{ textTransform: 'capitalize' }} variant='contained' disabled={!agree} color='primary' onClick={()=>navigateToMenu()}>Agree</Button>
                </DialogActions>
            </Dialog>
        </PageLayout>
    )
}